module.exports = __webpack_public_path__ + "img/avatar1.006e324d.png";